import React from 'react'
import styled from 'styled-components'
import * as Styles from './slide.module.scss'
const Slide = styled.div
`
max-height: 500px;
height: 100%;
width:100%;
`
const Grid = styled.div`
display:grid;
grid-template-columns: repeat(2, 1fr);
@media screen and (max-width:676px) {
  grid-template-columns: 1fr ;
}

`
const Background = styled.div`
    background: linear-gradient(181deg,rgb(161 191 189) 0%,rgb(209 220 214) 100%);
`
const ButtonDiv = styled.div`
button{
    font-size: 1.8rem;
    padding: 0.4rem 2rem;
    background: #383838;
    color:white;
    font-weight: 100;
}
`
const SlideShow = () => {
  return (
<Slide>
<Grid>
    <div className={Styles.background}>
    </div>
   <Background>
        <div className={Styles.textarea}>
        <h1>LUMINE</h1>
        <p>You can order sacs now,trending fashion for the year</p>
<ButtonDiv className='mt-4 center' >
        <button>Discover</button>
        </ButtonDiv>
        </div>
    </Background>
</Grid>
</Slide>
  )
}

export default SlideShow
